export default {
    lang: {
        name: 'Increased rating'
    }
}